import React from "react";
import Icon from "components/AppIcon";
import { useApp } from 'contexts/AppContext';

const StatCard = ({ icon, label, value, color }) => (
  <div className="flex items-center gap-3 p-4 rounded-xl border" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)", boxShadow: "var(--shadow-sm)" }}>
    <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${color}18` }}>
      <Icon name={icon} size={20} color={color} />
    </div>
    <div>
      <p className="font-data text-xl font-bold" style={{ color: "var(--color-foreground)" }}>{value}</p>
      <p className="font-caption text-xs" style={{ color: "var(--color-muted-foreground)" }}>{label}</p>
    </div>
  </div>
);

const SummaryPanel = ({ players }) => {
  const { games } = useApp();
  const totalPlayers = players?.length;
  const recentAdditions = players?.filter((p) => {
    const added = new Date(p.addedDate);
    const cutoff = new Date("2026-03-05");
    cutoff?.setDate(cutoff?.getDate() - 30);
    return added >= cutoff;
  })?.length;
  const avgWinPct = totalPlayers > 0 ? Math.round(players?.reduce((s, p) => s + p?.winPct, 0) / totalPlayers) : 0;
  const totalGames = games?.length || 0;

  const positions = players?.reduce((acc, p) => { acc[p.position] = (acc?.[p?.position] || 0) + 1; return acc; }, {});
  const posEntries = Object.entries(positions)?.sort((a, b) => b?.[1] - a?.[1]);

  return (
    <div className="space-y-4">
      <h3 className="font-heading font-semibold text-base" style={{ color: "var(--color-foreground)" }}>Roster Summary</h3>
      <div className="grid grid-cols-2 lg:grid-cols-1 gap-3">
        <StatCard icon="Users" label="Total Players" value={totalPlayers} color="var(--color-primary)" />
        <StatCard icon="UserPlus" label="Added This Month" value={recentAdditions} color="var(--color-success)" />
        <StatCard icon="Trophy" label="Avg Win Rate" value={`${avgWinPct}%`} color="var(--color-accent)" />
        <StatCard icon="Gamepad2" label="Total Games" value={totalGames} color="var(--color-secondary)" />
      </div>
      {posEntries?.length > 0 && (
        <div className="rounded-xl border p-4" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)", boxShadow: "var(--shadow-sm)" }}>
          <p className="font-caption font-semibold text-sm mb-3" style={{ color: "var(--color-foreground)" }}>Position Breakdown</p>
          <div className="space-y-2">
            {posEntries?.map(([pos, count]) => (
              <div key={pos} className="flex items-center justify-between">
                <span className="font-caption text-sm" style={{ color: "var(--color-muted-foreground)" }}>{pos}</span>
                <div className="flex items-center gap-2">
                  <div className="w-20 h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: "var(--color-muted)" }}>
                    <div className="h-full rounded-full" style={{ width: `${(count / totalPlayers) * 100}%`, backgroundColor: "var(--color-primary)" }} />
                  </div>
                  <span className="font-data text-xs font-semibold w-4 text-right" style={{ color: "var(--color-foreground)" }}>{count}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SummaryPanel;